"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = _interopRequireDefault(require("D:\\\u9879\u76EE\u7BA1\u7406\\\u65E7\u6362\u65B0\\\u6E90\u7801\\yijiuhuanxin_project_java\\WebPcAdmin\\node_modules\\@babel\\runtime\\regenerator\\index.js"));

var _dashboard = require("@/api/dashboard");

var _index2 = _interopRequireDefault(require("@/components/echarts/index"));

var _permission = require("@/utils/permission");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

// 权限判断函数
var _default = {
  components: {
    echartsFrom: _index2.default
  },
  data: function data() {
    return {
      infoList: null,
      visitDate: 'last30',
      series: [],
      xAxis: [],
      info: {},
      legendData: [],
      yAxisData: []
    };
  },
  mounted: function mounted() {
    this.yAxisData = [{
      type: 'value',
      name: '金额',
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      },
      axisLabel: {
        textStyle: {
          color: '#7F8B9C'
        }
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: '#F5F7F9'
        }
      }
    }, {
      type: 'value',
      name: '数量',
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      },
      axisLabel: {
        textStyle: {
          color: '#7F8B9C'
        }
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: '#F5F7F9'
        }
      } // axisLabel: {
      //     formatter: '{value} °C'
      // }

    }];
  },
  methods: {
    checkPermi: _permission.checkPermi,
    radioChange: function radioChange(val) {
      switch (val) {
        case 'week':
          this.handleChangeWeek();
          break;

        case 'month':
          this.handleChangeMonth();
          break;

        case 'year':
          this.handleChangeYear();
          break;

        default:
          this.handleChangeVisitType();
          break;
      }
    },
    // 时间改变
    handleChangeVisitType: function handleChangeVisitType() {
      var _this = this;

      this.xAxis = [];
      this.legendData = [];
      (0, _dashboard.chartOrder30Api)().then( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_index.default.mark(function _callee(res) {
          var pices, qualitys, key, _key;

          return _index.default.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _this.info = res;
                  pices = [];
                  qualitys = [];

                  for (key in res.price) {
                    pices.push(Number(res.price[key]));

                    _this.xAxis.push(key);
                  }

                  for (_key in res.quality) {
                    qualitys.push(Number(res.quality[_key]));
                  }

                  _this.legendData = ['订单金额', '订单数'];
                  _this.series = [{
                    name: "订单金额",
                    type: "bar",
                    itemStyle: {
                      normal: {
                        color: '#5B8FF9'
                      }
                    },
                    data: pices
                  }, {
                    name: "订单数",
                    type: "line",
                    smooth: true,
                    itemStyle: {
                      normal: {
                        color: '#4BCAD5'
                      }
                    },
                    yAxisIndex: 1,
                    data: qualitys
                  }];

                case 7:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    handleChangeWeek: function handleChangeWeek() {
      var _this2 = this;

      this.xAxis = [];
      this.legendData = [];
      (0, _dashboard.chartOrderWeekApi)().then( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_index.default.mark(function _callee2(res) {
          var prePrice, price, qualitys, preQuality, key, _key2, _key3, _key4;

          return _index.default.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _this2.info = res;
                  _this2.legendData = ["上周金额", "本周金额", "上周订单数", "本周订单数"];
                  prePrice = [];
                  price = [];
                  qualitys = [];
                  preQuality = [];

                  for (key in res.prePrice) {
                    prePrice.push(Number(res.prePrice[key]));

                    _this2.xAxis.push(key);
                  }

                  for (_key2 in res.price) {
                    price.push(Number(res.price[_key2]));
                  }

                  for (_key3 in res.preQuality) {
                    preQuality.push(Number(res.preQuality[_key3]));
                  }

                  for (_key4 in res.quality) {
                    qualitys.push(Number(res.quality[_key4]));
                  }

                  _this2.series = [{
                    name: "上周金额",
                    type: "bar",
                    itemStyle: {
                      normal: {
                        color: '#5B8FF9'
                      }
                    },
                    data: prePrice
                  }, {
                    name: "本周金额",
                    type: "bar",
                    itemStyle: {
                      normal: {
                        color: '#4BCAD5'
                      }
                    },
                    data: price
                  }, {
                    name: "上周订单数",
                    type: "line",
                    smooth: true,
                    itemStyle: {
                      normal: {
                        color: '#E6A23C'
                      }
                    },
                    yAxisIndex: 1,
                    data: preQuality
                  }, {
                    name: "本周订单数",
                    type: "line",
                    smooth: true,
                    itemStyle: {
                      normal: {
                        color: '#768A9C'
                      }
                    },
                    yAxisIndex: 1,
                    data: qualitys
                  }];

                case 11:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }());
    },
    handleChangeMonth: function handleChangeMonth() {
      var _this3 = this;

      this.xAxis = [];
      this.legendData = [];
      (0, _dashboard.chartOrderMonthApi)().then( /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/_index.default.mark(function _callee3(res) {
          var prePrice, price, qualitys, preQuality, key, _key5, _key6, _key7;

          return _index.default.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _this3.info = res;
                  _this3.legendData = ["上月金额", "本月金额", "上月订单数", "本月订单数"];
                  prePrice = [];
                  price = [];
                  qualitys = [];
                  preQuality = [];

                  for (key in res.prePrice) {
                    prePrice.push(Number(res.prePrice[key]));

                    _this3.xAxis.push(key);
                  }

                  for (_key5 in res.price) {
                    price.push(Number(res.price[_key5]));
                  }

                  for (_key6 in res.preQuality) {
                    preQuality.push(Number(res.preQuality[_key6]));
                  }

                  for (_key7 in res.quality) {
                    qualitys.push(Number(res.quality[_key7]));
                  }

                  _this3.series = [{
                    name: "上月金额",
                    type: "bar",
                    itemStyle: {
                      "normal": {
                        color: '#5B8FF9'
                      }
                    },
                    data: prePrice
                  }, {
                    name: "本月金额",
                    type: "bar",
                    itemStyle: {
                      "normal": {
                        color: '#4BCAD5'
                      }
                    },
                    data: price
                  }, {
                    name: "上月订单数",
                    type: "line",
                    smooth: true,
                    itemStyle: {
                      "normal": {
                        color: '#E6A23C'
                      }
                    },
                    yAxisIndex: 1,
                    data: preQuality
                  }, {
                    name: "本月订单数",
                    type: "line",
                    smooth: true,
                    itemStyle: {
                      "normal": {
                        color: '#768A9C'
                      }
                    },
                    yAxisIndex: 1,
                    data: qualitys
                  }];

                case 11:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        return function (_x3) {
          return _ref3.apply(this, arguments);
        };
      }());
    },
    handleChangeYear: function handleChangeYear() {
      var _this4 = this;

      this.xAxis = [];
      this.legendData = [];
      (0, _dashboard.chartOrderYearApi)().then( /*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/_index.default.mark(function _callee4(res) {
          var prePrice, price, qualitys, preQuality, key, _key8, _key9, _key10;

          return _index.default.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  _this4.info = res;
                  _this4.legendData = ["去年金额", "今年金额", "去年订单数", "今年订单数"];
                  prePrice = [];
                  price = [];
                  qualitys = [];
                  preQuality = [];

                  for (key in res.prePrice) {
                    prePrice.push(Number(res.prePrice[key]));

                    _this4.xAxis.push(key);
                  }

                  for (_key8 in res.price) {
                    price.push(Number(res.price[_key8]));
                  }

                  for (_key9 in res.preQuality) {
                    preQuality.push(Number(res.preQuality[_key9]));
                  }

                  for (_key10 in res.quality) {
                    qualitys.push(Number(res.quality[_key10]));
                  }

                  _this4.series = [////let col = ["#B37FEB", "#FFAB2B", "#1890FF", "#00C050"];
                  {
                    name: "去年金额",
                    type: "bar",
                    itemStyle: {
                      "normal": {
                        color: '#5B8FF9'
                      }
                    },
                    data: prePrice
                  }, {
                    name: "今年金额",
                    type: "bar",
                    itemStyle: {
                      "normal": {
                        color: '#4BCAD5'
                      }
                    },
                    data: price
                  }, {
                    name: "去年订单数",
                    type: "line",
                    smooth: true,
                    itemStyle: {
                      "normal": {
                        color: '#E6A23C'
                      }
                    },
                    yAxisIndex: 1,
                    data: preQuality
                  }, {
                    name: "今年订单数",
                    type: "line",
                    smooth: true,
                    itemStyle: {
                      "normal": {
                        color: '#768A9C'
                      }
                    },
                    yAxisIndex: 1,
                    data: qualitys
                  }];

                case 11:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        }));

        return function (_x4) {
          return _ref4.apply(this, arguments);
        };
      }());
    },
    // 监听页面宽度变化，刷新表格
    handleResize: function handleResize() {
      if (this.infoList) this.$refs.visitChart.handleResize();
    }
  },
  created: function created() {
    this.handleChangeVisitType();
  }
};
exports.default = _default;